import FJMyLike from './FJMyLike';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../../hooks/useLocalStore';
import { useEffect, useCallback } from 'react';
import FJActionCommunity from '../../../../../redux/action/FJActionCommunity';
import FJConstant from '../../../../../constants/FJConstant';
const FJMyLikeContainer = props => {
    useLocalStore();
    const { active } = props;
    const dispatch = useDispatch();
    const likedCreationsList = useSelector(state => state.community.likedCreationsList);
    const likedCreationsPageInfo = useSelector(state => state.community.likedCreationsPageInfo);
    useEffect(() => {
        dispatch(FJActionCommunity.initLikedCreationsListAction());
    }, [dispatch]);
    const getMoreLikedCreationsListAction = useCallback(() => {
        dispatch(FJActionCommunity.getMoreLikedCreationsListAction());
    }, [dispatch]);
    const changeNavBarTabToCommunity = useCallback(() => {
        dispatch(FJActionCommunity.changeNavBarTabAction(FJConstant.COMMUNITY));
    }, [dispatch]);
    return (
        <FJMyLike
            active={active}
            likedCreationsList={likedCreationsList}
            getMoreLikedCreationsData={getMoreLikedCreationsListAction}
            likedCreationsPageInfo={likedCreationsPageInfo}
            changeNavBarTabToCommunity={changeNavBarTabToCommunity}
        />
    );
};

FJMyLikeContainer.propTypes = {
    active: PropTypes.bool.isRequired,
};

export default FJMyLikeContainer;
